(function () {
  'use strict';

  var mobileMedia = window.matchMedia('(max-width: 749px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function nextFrame(callback) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(callback);
    });
  }

  function scrollToElement(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function setOfferSelection(variantId) {
    toArray(document.querySelectorAll('[data-j4-offer-card]')).forEach(function (card) {
      var selected = String(card.dataset.variantId) === String(variantId);
      var selectButton = card.querySelector('[data-j4-select-offer]');
      var selectLabel = card.querySelector('[data-j4-select-label]');

      card.classList.toggle('is-selected', selected);
      if (!selectButton) return;

      selectButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selectLabel) {
        selectLabel.textContent = selected ? selectButton.dataset.selectedLabel : selectButton.dataset.selectLabel;
      }
      selectButton.setAttribute(
        'aria-label',
        (selected ? selectButton.dataset.selectedLabel : selectButton.dataset.selectLabel) + ': ' + (card.dataset.title || '')
      );
    });
  }

  function syncVariant(option) {
    if (!option) return;

    var variantId = option.dataset.variantId || '';
    var title = option.dataset.title || '';
    var price = option.dataset.price || '';
    var available = option.dataset.available === 'true';

    toArray(document.querySelectorAll('[data-jgr-sticky-title]')).forEach(function (node) {
      node.textContent = title;
    });
    toArray(document.querySelectorAll('[data-jgr-sticky-price]')).forEach(function (node) {
      node.textContent = price;
    });
    toArray(document.querySelectorAll('[data-jgr-sticky-action]')).forEach(function (button) {
      var bar = button.closest('[data-jgr-sticky]');
      button.disabled = Boolean(bar && bar.dataset.jgrStickyMode === 'add' && !available);
    });
    setOfferSelection(variantId);
    document.dispatchEvent(new CustomEvent('joistr:variant-change', {
      detail: { variantId: variantId, title: title, price: price, available: available }
    }));
  }

  function initHeader() {
    var header = document.querySelector('[data-jgr-ux-header]');
    if (!header || header.dataset.juxReady === 'true') return;
    header.dataset.juxReady = 'true';

    var progress = header.querySelector('[data-jgr-scroll-progress]');
    var navLinks = toArray(header.querySelectorAll('[data-jgr-nav-link]'));
    var navTargets = navLinks.map(function (link) {
      var hash = '';
      try {
        var url = new URL(link.href, window.location.href);
        if (url.pathname === window.location.pathname) hash = url.hash;
      } catch (error) {
        hash = '';
      }
      return { link: link, target: hash ? document.querySelector(hash) : null };
    }).filter(function (item) { return item.target; });
    var ticking = false;

    function updateHeader() {
      ticking = false;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var currentPosition = scrollTop + header.offsetHeight + 96;
      var activeItem = null;

      header.classList.toggle('is-scrolled', scrollTop > 12);
      if (progress) progress.style.transform = 'scaleX(' + Math.min(1, Math.max(0, scrollTop / scrollable)) + ')';

      navTargets.forEach(function (item) {
        if (item.target.offsetTop <= currentPosition) activeItem = item;
      });
      navLinks.forEach(function (link) {
        var active = activeItem && activeItem.link === link;
        link.classList.toggle('is-active', Boolean(active));
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateHeader();
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-jgr-gallery]');
    if (!gallery || gallery.dataset.juxReady === 'true') return;
    gallery.dataset.juxReady = 'true';

    var buttons = toArray(gallery.querySelectorAll('[data-jgr-gallery-button]'));
    var stage = gallery.querySelector('.jgr-gallery__stage');
    var current = gallery.querySelector('[data-jgr-gallery-current]');
    var previous = gallery.querySelector('[data-jgr-gallery-prev]');
    var next = gallery.querySelector('[data-jgr-gallery-next]');
    var pointerState = null;
    var suppressClick = false;

    function getActiveIndex() {
      return buttons.findIndex(function (button) {
        return button.getAttribute('aria-selected') === 'true';
      });
    }

    function activateIndex(index, focusButton) {
      var nextIndex = Math.min(buttons.length - 1, Math.max(0, index));
      if (!buttons[nextIndex] || nextIndex === getActiveIndex()) return;
      buttons[nextIndex].click();
      if (focusButton) buttons[nextIndex].focus();
      updateControls();
    }

    function updateControls() {
      var activeIndex = getActiveIndex();
      if (current) current.textContent = String(Math.max(0, activeIndex) + 1);
      if (previous) {
        previous.disabled = activeIndex <= 0;
        previous.setAttribute('aria-disabled', previous.disabled ? 'true' : 'false');
      }
      if (next) {
        next.disabled = activeIndex >= buttons.length - 1;
        next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
      }
    }

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(updateControls);
      buttons.forEach(function (button) {
        observer.observe(button, { attributes: true, attributeFilter: ['aria-selected'] });
      });
    }

    if (previous) previous.addEventListener('click', function () { activateIndex(getActiveIndex() - 1, false); });
    if (next) next.addEventListener('click', function () { activateIndex(getActiveIndex() + 1, false); });

    if (stage) {
      stage.dataset.jgrCanSwipe = buttons.length > 1 ? 'true' : 'false';

      stage.addEventListener('dragstart', function (event) {
        if (!event.target.closest('video')) event.preventDefault();
      });

      stage.addEventListener('pointerdown', function (event) {
        if (buttons.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) return;
        if (event.target.closest('button, a, video, input, select, textarea')) return;

        pointerState = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          lastX: event.clientX,
          startedAt: Date.now(),
          dragging: false,
          vertical: false
        };

        try { stage.setPointerCapture(event.pointerId); } catch (error) { /* Pointer capture is an enhancement. */ }
      });

      stage.addEventListener('pointermove', function (event) {
        if (!pointerState || event.pointerId !== pointerState.id) return;
        var deltaX = event.clientX - pointerState.startX;
        var deltaY = event.clientY - pointerState.startY;
        pointerState.lastX = event.clientX;

        if (!pointerState.dragging && !pointerState.vertical) {
          if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
          if (Math.abs(deltaY) > Math.abs(deltaX)) {
            pointerState.vertical = true;
            return;
          }
          pointerState.dragging = true;
          stage.classList.add('is-dragging');
        }

        if (!pointerState.dragging) return;
        event.preventDefault();
        var resistedOffset = Math.max(-130, Math.min(130, deltaX * 0.72));
        stage.style.setProperty('--jgr-drag-offset', resistedOffset + 'px');
      });

      function finishPointer(event, cancelled) {
        if (!pointerState || event.pointerId !== pointerState.id) return;
        var state = pointerState;
        pointerState = null;

        stage.classList.remove('is-dragging');
        stage.style.removeProperty('--jgr-drag-offset');
        try { stage.releasePointerCapture(event.pointerId); } catch (error) { /* Capture may already be released. */ }

        if (cancelled || !state.dragging) return;

        var deltaX = event.clientX - state.startX;
        var elapsed = Math.max(1, Date.now() - state.startedAt);
        var velocity = Math.abs(deltaX) / elapsed;
        var distanceThreshold = Math.min(90, Math.max(46, stage.clientWidth * 0.12));
        var isSwipe = Math.abs(deltaX) >= distanceThreshold || (Math.abs(deltaX) >= 28 && velocity >= 0.45);

        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 0);
        if (isSwipe) activateIndex(getActiveIndex() + (deltaX < 0 ? 1 : -1), false);
      }

      stage.addEventListener('pointerup', function (event) { finishPointer(event, false); });
      stage.addEventListener('pointercancel', function (event) { finishPointer(event, true); });
      stage.addEventListener('lostpointercapture', function (event) { finishPointer(event, true); });
      stage.addEventListener('click', function (event) {
        if (!suppressClick || event.target.closest('[data-jgr-gallery-prev], [data-jgr-gallery-next]')) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    updateControls();
  }

  function initPicker(root) {
    var options = toArray(root.querySelectorAll('[data-jgr-variant-option]'));
    if (!options.length || root.dataset.juxPickerReady === 'true') return;
    root.dataset.juxPickerReady = 'true';

    function enabledOptions() {
      return options.filter(function (option) { return !option.disabled; });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        nextFrame(function () {
          options.forEach(function (candidate) { candidate.tabIndex = candidate === option ? 0 : -1; });
          syncVariant(option);
        });
      });

      option.addEventListener('keydown', function (event) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        var availableOptions = enabledOptions();
        var currentIndex = availableOptions.indexOf(option);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % availableOptions.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + availableOptions.length) % availableOptions.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = availableOptions.length - 1;

        availableOptions[nextIndex].focus();
        availableOptions[nextIndex].click();
      });
    });

    nextFrame(function () {
      var selected = root.querySelector('[data-jgr-variant-option].is-selected') || enabledOptions()[0];
      options.forEach(function (option) { option.tabIndex = option === selected ? 0 : -1; });
      syncVariant(selected);
    });
  }

  function initOfferCards(root) {
    var grid = root.querySelector('[data-j4-offer-grid]');
    if (!grid || grid.dataset.juxReady === 'true') return;
    grid.dataset.juxReady = 'true';

    var cards = toArray(grid.querySelectorAll('[data-j4-offer-card]'));
    var dots = toArray(root.querySelectorAll('[data-j4-offer-dot]'));
    var scrollTicking = false;

    function heroOptionFor(variantId) {
      return toArray(document.querySelectorAll('[data-jgr-variant-option]')).find(function (option) {
        return String(option.dataset.variantId) === String(variantId);
      });
    }

    function selectCard(card, shouldScroll) {
      if (!card) return;
      var selectButton = card.querySelector('[data-j4-select-offer]');
      if (selectButton && selectButton.disabled) return;

      var heroOption = heroOptionFor(card.dataset.variantId);
      if (heroOption && !heroOption.disabled) heroOption.click();
      else setOfferSelection(card.dataset.variantId);

      if (shouldScroll && mobileMedia.matches) {
        grid.scrollTo({
          left: card.offsetLeft - Math.max(0, (grid.clientWidth - card.offsetWidth) / 2),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }
    }

    cards.forEach(function (card) {
      var selectButton = card.querySelector('[data-j4-select-offer]');
      var form = card.querySelector('.j4-product-form');
      if (selectButton) selectButton.addEventListener('click', function () { selectCard(card, true); });
      if (form) form.addEventListener('submit', function () { selectCard(card, false); });
      card.addEventListener('click', function (event) {
        var interactive = event.target.closest && event.target.closest('button, a, input, label, form');
        if (!interactive) selectCard(card, false);
      });
    });

    function updateDots() {
      scrollTicking = false;
      if (!cards.length || !dots.length) return;
      var center = grid.scrollLeft + grid.clientWidth / 2;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - center);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.setAttribute('aria-pressed', index === nearestIndex ? 'true' : 'false');
      });
    }

    grid.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateDots);
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var card = document.getElementById(dot.dataset.cardId);
        if (!card) return;
        grid.scrollTo({
          left: card.offsetLeft - Math.max(0, (grid.clientWidth - card.offsetWidth) / 2),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      });
    });

    nextFrame(function () {
      if (mobileMedia.matches) {
        var selected = grid.querySelector('[data-j4-offer-card].is-selected');
        if (selected) grid.scrollLeft = selected.offsetLeft - Math.max(0, (grid.clientWidth - selected.offsetWidth) / 2);
      }
      updateDots();
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-jgr-sticky]');
    var purchase = document.querySelector('[data-jgr-purchase]');
    if (!bar || !purchase || bar.dataset.juxReady === 'true') return;
    bar.dataset.juxReady = 'true';

    var button = bar.querySelector('[data-jgr-sticky-action]');
    var offer = document.querySelector('#joistr-offer');
    var footer = document.querySelector('.jgr-footer');
    var visibility = { purchase: true, offer: false, footer: false };

    function updateVisibility() {
      var hidden = visibility.purchase || visibility.offer || visibility.footer;
      bar.classList.toggle('is-hidden', hidden);
      document.body.classList.toggle('jux-sticky-visible', !hidden);
    }

    function observe(element, key, threshold) {
      if (!element || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        visibility[key] = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: threshold });
      observer.observe(element);
    }

    observe(purchase, 'purchase', 0.08);
    observe(offer, 'offer', 0.04);
    observe(footer, 'footer', 0.04);

    if (button) {
      button.dataset.originalText = button.textContent;
      button.addEventListener('click', function () {
        var mode = bar.dataset.jgrStickyMode || 'add';
        var form = document.querySelector('[data-jgr-product-form]');
        var submit = form ? form.querySelector('[data-jgr-main-submit]') : null;

        if (mode === 'add' && form && submit && !submit.disabled) {
          button.setAttribute('aria-busy', 'true');
          button.textContent = 'ADDING…';
          if (form.requestSubmit) form.requestSubmit(submit);
          else submit.click();
          window.setTimeout(function () {
            button.removeAttribute('aria-busy');
            button.textContent = button.dataset.originalText;
          }, 3200);
          return;
        }
        scrollToElement(purchase);
      });
    }

    updateVisibility();
  }

  function initAccordions(scope) {
    toArray(scope.querySelectorAll('[data-jgr-accordion-group]')).forEach(function (group) {
      if (group.dataset.juxReady === 'true' || group.dataset.singleOpen !== 'true') return;
      group.dataset.juxReady = 'true';
      toArray(group.querySelectorAll('details')).forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          toArray(group.querySelectorAll('details[open]')).forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  }

  function initReveal(scope) {
    if (reducedMotion || (window.Shopify && window.Shopify.designMode)) return;
    var nodes = toArray(scope.querySelectorAll('[data-jgr-root]:not(.jgr--header), [data-joistr-section]'));
    if (!nodes.length) return;
    document.documentElement.classList.add('jux-ready');

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-jux-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, activeObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-jux-visible');
        activeObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    nodes.forEach(function (node) {
      if (node.dataset.juxRevealReady === 'true') return;
      node.dataset.juxRevealReady = 'true';
      if (node.getBoundingClientRect().top < window.innerHeight * 0.9) node.classList.add('is-jux-visible');
      else observer.observe(node);
    });
  }


  function initSafeCompactHeaders() {
    toArray(document.querySelectorAll('.j4-header, .jgr-header')).forEach(function (header, headerIndex) {
      if (header.dataset.joistrSafeHeader === 'true') return;
      header.dataset.joistrSafeHeader = 'true';

      var desktopNav = header.querySelector(':scope > nav, :scope > .jgr-nav');
      var desktopCta = header.querySelector(':scope > .j4-button, :scope > .jgr-button');
      var actions = document.createElement('div');
      actions.className = 'joistr-safe-actions';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cart = document.createElement('a');
      cart.className = 'joistr-safe-cart';
      cart.href = root + 'cart';
      cart.setAttribute('aria-label', 'Cart');
      cart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 1.9-1.4L21 7H7"></path><circle cx="10" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle></svg><span class="joistr-safe-cart__count" data-joistr-safe-cart-count>0</span>';
      actions.appendChild(cart);

      var menu = document.createElement('div');
      menu.className = 'joistr-safe-menu';

      var toggle = document.createElement('button');
      toggle.className = 'joistr-safe-menu__toggle';
      toggle.type = 'button';
      toggle.setAttribute('aria-label', 'Open menu');
      toggle.setAttribute('aria-expanded', 'false');
      var panelId = 'joistr-safe-menu-panel-' + headerIndex;
      toggle.setAttribute('aria-controls', panelId);
      toggle.innerHTML = '<svg class="joistr-safe-menu__open-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"></path></svg><svg class="joistr-safe-menu__close-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
      menu.appendChild(toggle);
      actions.appendChild(menu);
      header.appendChild(actions);

      /* Render the dropdown at body level so it cannot be clipped by any
         sticky header/section overflow or stacking context. */
      var panel = document.createElement('div');
      panel.className = 'joistr-safe-menu__panel';
      panel.id = panelId;
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');

      var nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Mobile navigation');
      if (desktopNav) {
        toArray(desktopNav.querySelectorAll('a')).forEach(function (link) {
          nav.appendChild(link.cloneNode(true));
        });
      }
      panel.appendChild(nav);
      if (desktopCta) {
        var cta = desktopCta.cloneNode(true);
        cta.className = 'joistr-safe-menu__cta';
        cta.textContent = 'GET JOISTR';
        /* Force JOISTR menu CTA ink at the element level. This prevents
           inherited/theme link states from turning the lime CTA text white. */
        cta.style.setProperty('color', '#11130f', 'important');
        cta.style.setProperty('-webkit-text-fill-color', '#11130f', 'important');
        panel.appendChild(cta);
      }
      document.body.appendChild(panel);

      function positionPanel() {
        var rect = header.getBoundingClientRect();
        panel.style.setProperty('--joistr-safe-menu-top', Math.max(0, Math.round(rect.bottom)) + 'px');
        var bg = window.getComputedStyle(header).backgroundColor;
        if (bg) panel.style.setProperty('--joistr-safe-menu-paper', bg);
      }

      function closeMenu() {
        menu.classList.remove('is-open');
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        panel.setAttribute('aria-hidden', 'true');
        panel.hidden = true;
        panel.style.display = '';
        document.documentElement.classList.remove('joistr-menu-open');
      }

      function openMenu() {
        positionPanel();
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        panel.hidden = false;
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.display = 'block';
        window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
        document.documentElement.classList.add('joistr-menu-open');
      }

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (menu.classList.contains('is-open')) closeMenu();
        else openMenu();
      });

      panel.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a');
        if (link) closeMenu();
      });

      document.addEventListener('click', function (event) {
        if (!menu.classList.contains('is-open')) return;
        if (!menu.contains(event.target) && !panel.contains(event.target)) closeMenu();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.classList.contains('is-open')) {
          closeMenu();
          toggle.focus();
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 989) closeMenu();
        else if (menu.classList.contains('is-open')) positionPanel();
      }, { passive: true });

      window.addEventListener('scroll', function () {
        if (menu.classList.contains('is-open')) positionPanel();
      }, { passive: true });
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (window.fetch) {
      window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          toArray(document.querySelectorAll('[data-joistr-safe-cart-count]')).forEach(function (node) {
            node.textContent = String(cart.item_count || 0);
          });
        })
        .catch(function () {});
    }
  }

  function initSafeStickyBuy() {
    var offer = document.querySelector('#joistr-offer');
    if (!offer || document.querySelector('[data-joistr-safe-sticky]')) return;

    var cards = toArray(offer.querySelectorAll('[data-j4-offer-card]'));
    if (!cards.length) return;

    var selected = offer.querySelector('[data-j4-offer-card].is-selected') || cards[1] || cards[0];
    var stickyProductLabel = offer.dataset.stickyProductLabel || 'JOISTR Crawler Pads';
    var stickyButtonLabel = offer.dataset.stickyButtonLabel || 'ADD TO CART';
    var stickySaveLabel = (offer.dataset.saveLabel || 'Save').toUpperCase();
    var bar = document.createElement('div');
    bar.className = 'joistr-safe-sticky';
    bar.setAttribute('data-joistr-safe-sticky', '');
    bar.innerHTML = '<div class="joistr-safe-sticky__thumb" data-joistr-safe-sticky-thumb hidden><img data-joistr-safe-sticky-image src="" alt="" width="48" height="48" loading="eager" decoding="async"></div><div class="joistr-safe-sticky__copy" aria-live="polite"><div class="joistr-safe-sticky__line"><strong data-joistr-safe-sticky-product></strong><span class="joistr-safe-sticky__separator" aria-hidden="true"> &middot; </span><span data-joistr-safe-sticky-tier></span></div><div class="joistr-safe-sticky__meta"><s data-joistr-safe-sticky-compare hidden></s><strong data-joistr-safe-sticky-price></strong><span data-joistr-safe-sticky-saving-wrap hidden><span class="joistr-safe-sticky__meta-separator" aria-hidden="true"> &middot; </span><span data-joistr-safe-sticky-save-label></span> <b data-joistr-safe-sticky-saving></b></span></div></div><button class="joistr-safe-sticky__button" type="button" data-joistr-safe-sticky-button><span data-joistr-safe-sticky-button-label></span></button>';
    document.body.appendChild(bar);
    document.body.classList.add('joistr-safe-sticky-active');

    var thumbNode = bar.querySelector('[data-joistr-safe-sticky-thumb]');
    var imageNode = bar.querySelector('[data-joistr-safe-sticky-image]');
    var productNode = bar.querySelector('[data-joistr-safe-sticky-product]');
    var tierNode = bar.querySelector('[data-joistr-safe-sticky-tier]');
    var compareNode = bar.querySelector('[data-joistr-safe-sticky-compare]');
    var priceNode = bar.querySelector('[data-joistr-safe-sticky-price]');
    var savingWrap = bar.querySelector('[data-joistr-safe-sticky-saving-wrap]');
    var savingNode = bar.querySelector('[data-joistr-safe-sticky-saving]');
    var saveLabelNode = bar.querySelector('[data-joistr-safe-sticky-save-label]');
    var buttonLabelNode = bar.querySelector('[data-joistr-safe-sticky-button-label]');
    var button = bar.querySelector('[data-joistr-safe-sticky-button]');

    if (productNode) productNode.textContent = stickyProductLabel;
    if (saveLabelNode) saveLabelNode.textContent = stickySaveLabel;
    if (buttonLabelNode) buttonLabelNode.textContent = stickyButtonLabel;

    function sync(card) {
      if (!card) return;
      selected = card;
      var tier = (card.dataset.title || '').toUpperCase();
      var price = card.dataset.price || '';
      var comparePrice = card.dataset.comparePrice || '';
      var saving = card.dataset.saving || '';
      var stickyImage = card.dataset.stickyImage || '';
      var stickyImageAlt = card.dataset.stickyImageAlt || stickyProductLabel;

      if (thumbNode && imageNode) {
        if (stickyImage) {
          if (imageNode.getAttribute('src') !== stickyImage) imageNode.setAttribute('src', stickyImage);
          imageNode.setAttribute('alt', stickyImageAlt);
          thumbNode.hidden = false;
          bar.classList.add('has-thumbnail');
        } else {
          thumbNode.hidden = true;
          imageNode.removeAttribute('src');
          imageNode.setAttribute('alt', '');
          bar.classList.remove('has-thumbnail');
        }
      }

      if (tierNode) tierNode.textContent = tier;
      if (priceNode) priceNode.textContent = price;
      if (compareNode) {
        compareNode.textContent = comparePrice;
        compareNode.hidden = !comparePrice;
      }
      if (savingNode) savingNode.textContent = saving;
      if (savingWrap) savingWrap.hidden = !saving;
      button.disabled = card.dataset.available === 'false';
    }

    sync(selected);

    offer.addEventListener('click', function (event) {
      var card = event.target.closest && event.target.closest('[data-j4-offer-card]');
      if (!card) return;
      window.setTimeout(function () { sync(card); }, 0);
    });

    document.addEventListener('joistr:variant-change', function (event) {
      var detail = event.detail || {};
      var match = cards.find(function (card) { return String(card.dataset.variantId) === String(detail.variantId); });
      if (match) sync(match);
    });

    button.addEventListener('click', function () {
      if (!selected || button.disabled) return;
      var variantId = selected.dataset.variantId;
      if (!variantId) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'ADDING…';

      if (!window.fetch) {
        var form = selected.querySelector('form');
        if (form) form.submit();
        return;
      }

      window.fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      }).then(function (response) {
        return response.ok ? response.json() : null;
      }).then(function (cart) {
        if (cart) {
          toArray(document.querySelectorAll('[data-joistr-safe-cart-count]')).forEach(function (node) {
            node.textContent = String(cart.item_count || 0);
          });
        }
        button.textContent = 'ADDED ✓';
      }).catch(function () {
        var form = selected.querySelector('form');
        if (form) form.submit();
      }).finally(function () {
        window.setTimeout(function () {
          button.innerHTML = original;
          buttonLabelNode = button.querySelector('[data-joistr-safe-sticky-button-label]');
          if (buttonLabelNode) buttonLabelNode.textContent = stickyButtonLabel;
          sync(selected);
          button.disabled = selected && selected.dataset.available === 'false';
        }, 1400);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.05 });
      observer.observe(offer);
    }
  }

  function initAll(scope) {
    var target = scope || document;
    initHeader();
    initSafeCompactHeaders();
    toArray(target.querySelectorAll('[data-jgr-hero-root]')).forEach(function (root) {
      initGallery(root);
      initPicker(root);
    });
    toArray(target.querySelectorAll('[data-j4-offers]')).forEach(initOfferCards);
    initStickyBar();
    initSafeStickyBuy();
    initAccordions(target);
    initReveal(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#joistr-offer')) {
      var existingSticky = document.querySelector('[data-joistr-safe-sticky]');
      if (existingSticky) existingSticky.remove();
    }
    initAll(event.target);
  });
})();
